import {
  baseApi,
  CHALLENGES_TAG,
  type OmegaApiResponse,
} from '@shared/api';
import {
  type Challenge,
} from '@entities/challenges';

export type LimitedChallengesResponse = Partial<OmegaApiResponse> & {
  challenges: Array<Challenge>;
  title: string;
};

export const limitedChallengesApiSlicer = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getLimitedChallenges: build.query<LimitedChallengesResponse, void>({
      query: () => ({ url: '/api/ips/get-limited-challenges' }),
      providesTags: [CHALLENGES_TAG],
      extraOptions: { showLoader: false, auth: true },
    }),
  }),
});

export const {
  useGetLimitedChallengesQuery,
  useLazyGetLimitedChallengesQuery
} = limitedChallengesApiSlicer;
